module.exports = __webpack_public_path__ + "img/account-cog-outline.8b496789.svg";